export const COMPOSING = 'composing';
export const PAUSED = 'paused';

export type ChatStateType = typeof COMPOSING | typeof PAUSED;
